'use strict';

import $ from 'jquery';
import { onPageLoad } from '@/js/modules/page_load';

onPageLoad(() => {
  $('html').click(function (e) {
    const $target = $(e.target);

    if (!$target.is('.js-nav-menu__trigger')) {
      $('.nav-menu').removeClass('nav-menu--active');
    }
  });

  $(document).on('click', '.js-nav-menu__trigger', function () {
    $(this).closest('.user-nav').find('.nav-menu').toggleClass('nav-menu--active');
    return false;
  });

  $(document).on('click', '.js-mobile-menu', function () {
    $('.header__inner').toggleClass('header__inner--active active');
  });

  $(document).on('click', '.nav-menu__team', (e) => {
    $('.p-button--confirm-switch-team').attr('href', `/switch_team/${$(e.target).data('team-id')}`);
    $('.modal--switch-team-confirmation__body').text(
      `Switching to ${$(e.target).data(
        'team-name'
      )} will allow you to access any project(s) you have with this company.`
    );
    $('.modal--switch-team-confirmation').modal('show');
  });
});
